import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    console.log(data)

    if (data.client?.length === 0 || data.client === null)
        response.push(<Box>Selecione um Cliente.</Box>)

    if (data.discount?.length === 0 || data.discount === null)
        response.push(<Box>Selecione um Desconto.</Box>)

        if (data.monthlyvolume?.length === 0 || data.monthlyvolume === null)
        response.push(<Box>Digite o volume mensal.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData